import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styles/CreateProject.css"; // Custom CSS file
import LayOut from "../../components/LayOut";

const CreateProject = () => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    OutputUrl: "",
    photo: null,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, photo: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData();
    form.append("name", formData.name);
    form.append("description", formData.description);
    form.append("OutputUrl", formData.OutputUrl);
    if (formData.photo) form.append("photo", formData.photo);

    try {
      const response = await fetch(
        "https://portfoliomern-mxue.onrender.com/api/v1/project/create-project",
        {
          method: "POST",
          body: form,
        }
      );
      const data = await response.json();
      if (data.success) {
        alert("Project created successfully!");
      } else {
        alert(data.message || "Failed to create project");
      }
    } catch (error) {
      console.error("Error creating project:", error);
    }
  };

  return (
    <LayOut title={"Project"}>
      <div className="create-project-container">
        <div className="form-box">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Project Name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="mb-3">
              <input
                type="text"
                name="description"
                className="form-control"
                placeholder="Project Description"
                value={formData.description}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="mb-3">
              <input
                type="url"
                name="OutputUrl"
                className="form-control"
                placeholder="Output of Your Project"
                value={formData.OutputUrl}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="mb-3">
              <input
                type="file"
                name="photo"
                className="form-control"
                accept="image/*"
                onChange={handleFileChange}
              />
            </div>
            <button type="submit" className="btn btn-primary w-100">
              Submit
            </button>
          </form>
        </div>
      </div>
    </LayOut>
  );
};

export default CreateProject;
